import { ReactNode } from "react";
import { TooltipTrigger, Tooltip as Tip, TooltipContent } from "@/components/ui/tooltip";

type TooltipProps = {
  asChild?: boolean;
  content: ReactNode;
  side?: "top" | "bottom" | "left" | "right";
  trigger: ReactNode;
};
const Tooltip = ({ asChild = false, content, trigger, side }: TooltipProps) => {
  return (
    <Tip>
      <TooltipTrigger asChild={asChild}>{trigger}</TooltipTrigger>
      <TooltipContent side={side}>{content}</TooltipContent>
    </Tip>
  );
};

export default Tooltip;
